<template>
    <card class="spaced typo" v-show="loaded">

        <div class="pt-2" v-if="ctrl.rows.length || search">

            <h2 class="text-white">{{ $t('common.users') }}</h2>

            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <base-table :data="ctrl.rows" :columns="columns">

                <template slot="columns">
                    <th>{{ $t('common.name') }}</th>
                    <th>{{ $t('common.email') }}</th>
                    <th>{{ $t('common.entity') }}</th>
                    <th>{{ $t('common.role') }}</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <td :class="cellClass(row)">
                        <badge type="default" class="mr-1" v-if="$auth.user.id === row.id">
                            {{ $t('common.me') }}
                        </badge>
                        {{ row.name }}
                    </td>
                    <td :class="cellClass(row)">
                        {{ row.email }}
                    </td>
                    <td :class="cellClass(row)">
                        {{ entities[row.entity_id] }}
                    </td>
                    <td :class="cellClass(row)">
                        {{ roles[row.role_id] }}
                    </td>

                    <td class="td-actions text-right">

                        <base-button icon link size="md" type="info" @click="navToAgents(row)" v-if="agentsEditable">
                            <i class="tim-icons icon-multiple-19"></i>
                        </base-button>

                        <base-button icon link size="md" type="warning" @click="ctrl.update(row.id)">
                            <i class="tim-icons icon-pencil"></i>
                        </base-button>

                        <base-button icon link size="md" type="danger"
                            @click="ctrl.delete(row.id)"
                            v-if="row.id != $auth.user.id"
                        >
                            <i class="tim-icons icon-simple-remove"></i>
                        </base-button>

                    </td>
                </template>

            </base-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>

        </div>

        <p class="text-center py-3" v-else>{{ $t('users.no-user') }}</p>
                
        <div class="text-center">
            <base-button type="primary" @click="ctrl.create()">
                {{ $t('users.new') }}
            </base-button>
        </div>

        <portal to="modals">

            <modal class="no-footer" :title="$t('common.user')" v-model="ctrl.modals.edit" :loading="ctrl.form.loading">
                <user-form v-model="ctrl.form.data" :errors="ctrl.form.errors" :entities="entities" :roles="roles">
                </user-form>
            </modal>

            <modal-confirm v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('users.delete-confirm') }}</p>
            </modal-confirm>

        </portal>

    </card>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import UserForm from './UserForm'

    export default {

        components: {
            UserForm
        },

        computed: {
            agentsEditable() {
                return this.$auth.config.xapi.requests.relational
            }
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/users',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['firstname'],
                        include: ['roles', 'entities'],
                        filters: { owner_id: this.$auth.owner.id }
                    }
                }),
                search: '',
                columns: ['email', 'firstname', 'lastname', 'entity', 'role'],
                entities: {},
                roles: {},
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                if (!Array.isArray(resp.data.included.entities)) {
                    // This may happen when there is no entity.
                    this.entities = resp.data.included.entities
                }
                if (Array.isArray(resp.data.included.roles)) {
                    // We got an empty array. No role provided.
                    this.roles = {}
                } else {
                    // We get an object so there are some roles.
                    this.roles = resp.data.included.roles
                }
                if (this.$auth.user.admin) {
                    // Only admins are allowed to create other admin accounts.
                    this.roles[0] = this.$t('common.admin')
                }
            })
        },

        watch: {
            search(val) {
                this.ctrl.filter({ 
                    simpleSearch: val,
                    owner_id: this.$auth.owner.id,
                })
            }
        },

        methods: {
            
            mapData(user) {
                return {
                    id: user ? user.id : null,
                    email: user ? user.email : null,
                    firstname: user ? user.firstname : null,
                    lastname: user ? user.lastname : null,
                    password: null,
                    entity_id: user ? user.entity_id : (this.$auth.user.entity_id ? this.$auth.user.entity_id : null),
                    role_id: user ? (user.admin ? '0' : user.role_id) : null,
                    admin: user ? user.admin : false,
                    active: user ? user.active : true,
                    name: user ? user.name : null,
                }
            },

            unmapData(data) {
                let user = {...data}
                if (user.role_id === '0') {
                    user.role_id = null
                    user.admin = true
                } else {
                    user.admin = false
                }
                user.owner_id = this.$auth.owner.id
                user.username = user.email
                return user
            },

            cellClass(row) {
                return row.active ? '' : 'disabled'
            },

            navToAgents(row) {
                this.$router.push({ name: 'user-agents', params: { id: row.id } })
            }
        }
    }
</script>

<style scoped>

    td.disabled {
        color: #777 !important;
    }

</style>
